import React, { useEffect } from "react";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/dailyPulseSagas";
import { useDispatch, useSelector } from "react-redux";
import ReactDatePicker from "../../components/reactDatePicker/reactDatePicker";
import { SECTIONS } from "./constants";
import { withLoadingAnimation } from "./HOCs/withLoadingAnimation";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../constants/ilearnUrls";

const allSections = SECTIONS.map(({ Component, key, urn, ...rest }) => {
  const Section = withLoadingAnimation(Component, key, urn);
  // eslint-disable-next-line react/display-name
  return (notifications, showChart) =>
    showChart[key] ? <Section key={key} notifications={notifications} {...rest} /> : null;
});

const DailyPulseModule = ({ showChart, ...restProps }) => {
  const date = useSelector((state) => state.dailyPulse.date);
  const { notifications, dateFormat } = useSelector((state) => state.commonReducer.commonProps);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(restProps));
  }, []);

  const updateDates = (date) => dispatch(actionCreators.updateDate(date));

  const content = () => {
    return (
      <div className="dailyPulse">
        <div className="edit-selections-bar">
          <div className="date-select-box">
            <p className="offers-title">Date</p>
            <ReactDatePicker
              displayFormat={dateFormat}
              startDate={date ? date : restProps.calendarEndDate}
              calendarEndDate={restProps.calendarEndDate}
              minDate={restProps.calendarStartDate}
              updateDates={updateDates}
            />
          </div>
        </div>

        <>{allSections.map((section) => section(notifications, showChart))}</>
      </div>
    );
  };
  return (
    <SectionToggle
      title="Daily Pulse"
      hideToggle
      learnMore={
        <KBLearnMore
          title="Daily Pulse"
          description="This report shows a daily snapshot of key operational metrics, along with your progress toward monthly performance goals. These insights help you track day-to-day shifts, identify early trends, and stay aligned with monthly targets."
          kbUrl={ILEARN_URLS.dailyPulse.dailyPulse}
        />
      }
      content={content()}
    />
  );
};

export default DailyPulseModule;
